import categoryRedirects from '~/config/category-redirects.json'

/**
 * Category URL changes in the Typesense migration (algolia-sync-checker/raportit/kategoria-uudelleenohjaukset-2026-09-28.xlsx).
 *
 * The old category paths came from the Frends Algolia category index (typed by hand in Struct),
 * the Typesense paths are derived from the category tree names. Each rule moves a category and its
 * whole subtree: the longest matching prefix wins. config/category-redirects.json is sorted longest first.
 *
 * A prefix only matches on a path segment boundary: ".../ktm" must not match its new path ".../ktm-crossi-ja-enduropyorat".
 */

interface CategoryRedirectRule {
  from: string
  to: string
}

const LOCALE_PREFIX = /^\/[a-z]{2}(?=\/category\/)/

export function resolveCategoryRedirect(path: string, rules: CategoryRedirectRule[] = categoryRedirects): string | null {
  const locale = LOCALE_PREFIX.exec(path)?.[0] ?? ''
  const localPath = path.slice(locale.length).replace(/\/+$/, '')
  if (!localPath.startsWith('/category/')) return null

  const rule = rules.find(r => localPath === r.from || localPath.startsWith(r.from + '/'))
  if (!rule) return null

  return locale + rule.to + localPath.slice(rule.from.length)
}
